import React from 'react';
import { getProductThumb, getRealImage } from '../../data/productImages';

const BRAND_COLORS: Record<string, string> = {
  'HP': '#0096D6', 'BROTHER': '#004B87', 'CANON': '#CC0000', 'KYOCERA MITA': '#C8102E',
  'RICOH': '#E60012', 'XEROX': '#D91B5C', 'SAMSUNG': '#1428A0', 'EPSON': '#003399',
  'LEXMARK': '#FF6600', 'OKI': '#E2001A', 'TOSHIBA': '#EE1D23', 'OLIVETTI': '#00479D',
  'KONICA': '#00205B',
};

const COLOR_MAP: Record<string, string> = {
  'Nero': '#374151', 'Ciano': '#0891B2', 'Magenta': '#DB2777', 'Giallo': '#CA8A04',
  'Set CMYK': '#6366F1', 'Nero + Colore': '#4B5563', 'Set 5 colori': '#8B5CF6',
};

interface ProductThumbProps {
  sku: string;
  brand: string;
  color?: string;
  category?: string;
  size?: 'sm' | 'md' | 'lg';
  className?: string;
}

export function ProductThumb({ sku, brand, color, category, size = 'md', className = '' }: ProductThumbProps) {
  const brandColor = BRAND_COLORS[brand] || '#6B7280';
  const productColor = (color && COLOR_MAP[color]) || brandColor;

  const sizes = {
    sm: 'w-12 h-12',
    md: 'w-20 h-20',
    lg: 'w-[86px] h-[77px] sm:w-[115px] sm:h-[104px]',   // responsive: altezza ridotta ~10% aggiuntivo
  };

  // Miniatura: priorità alla foto reale caricata (indipendentemente dalla
  // categoria, non sempre disponibile in questo componente — es. Preferiti,
  // Carrello, Avvisi Stock). Solo se manca del tutto si ricade sul
  // placeholder di categoria, e infine sull'iniziale marca.
  const imgSrc = getRealImage(sku) || (category ? getProductThumb(sku, category) : null);

  if (imgSrc) {
    return (
      <div
        className={`${sizes[size]} rounded-xl border overflow-hidden flex items-center justify-center flex-shrink-0 bg-white ${className}`}
      >
        <img
          src={imgSrc}
          alt={sku}
          className="w-full h-full object-contain p-1"
          loading="lazy"
        />
      </div>
    );
  }

  // Fallback: lettera brand (quando category non è disponibile)
  const initial = brand ? brand.charAt(0) : '?';
  const initFontSizes = { sm: 'text-xl', md: 'text-3xl', lg: 'text-5xl' };

  return (
    <div
      className={`${sizes[size]} rounded-xl border overflow-hidden flex items-center justify-center flex-shrink-0 ${className}`}
      style={{ backgroundColor: `${productColor}10` }}
    >
      <span className={`${initFontSizes[size]} font-black`} style={{ color: `${productColor}88` }}>{initial}</span>
    </div>
  );
}
